<template>
    <div v-if="items && items.length">
        <y-row class="b-blog-grid b-blog-grid--grid">
            <y-col class="px-2">
                <y-rogue-wrapper
                    name="blog-card"
                    type="multimedia"
                    :element="items[0]"
                />
            </y-col>
            <y-col class="px-2">
                <y-row class="h-50">
                    <y-col class="pb-2">
                        <y-rogue-wrapper
                            v-if="items[1]"
                            name="blog-card"
                            type="multimedia"
                            :element="items[1]"
                        />
                    </y-col>
                </y-row>
                <y-row class="h-50">
                    <y-col
                        size="6"
                        class="pt-2 pl-2"
                    >
                        <y-rogue-wrapper
                            v-if="items[2]"
                            name="blog-card"
                            type="multimedia"
                            :element="items[2]"
                        />
                    </y-col>
                    <y-col
                        size="6"
                        class="pt-2 pr-2"
                    >
                        <y-rogue-wrapper
                            v-if="items[3]"
                            name="blog-card"
                            type="multimedia"
                            :element="items[3]"
                        />
                    </y-col>
                </y-row>
            </y-col>
        </y-row>
        <y-row class="b-blog-grid b-blog-grid--slideshow">
            <y-slideshow
                type="simple"
                pagination="6"
                pagination-no-bg
            >
                <y-slide
                    v-for="slide in items"
                    :key="slide.id"
                    class="b-blog-grid__slide-item"
                >
                    <y-rogue-wrapper
                        name="blog-card"
                        type="multimedia"
                        :element="slide"
                    />
                </y-slide>
            </y-slideshow>
        </y-row>
    </div>
</template>

<script>
    import { YCol, YRow, YSlide } from '@components';
    import { YSlideshow } from '@rogues';
    
    export default {

        name: 'BlogGrid',

        components: {
            YCol,
            YRow,
            YSlide,
            YSlideshow,
        },

        props: {
            items: {
                type: Array,
            },
        },

    };
</script>
